import { GridItem as ChakraGridItem } from "@chakra-ui/react";
import type { ComponentProps } from "react";
import type { GridItemSharedProps } from "./GridItem.props";

type ChakraGridItemProps = ComponentProps<typeof ChakraGridItem>;

export type GridItemProps = GridItemSharedProps & {
  // Add any web specific props here.
};

export default function GridItem(props: GridItemProps): JSX.Element {
  return <ChakraGridItem {...(props as unknown as ChakraGridItemProps)} />;
}
